import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams,
    useFetcher
} from "react-router-dom"
import { GlobalContext } from '../GlobalContext'

import Button from '../formfields/Button'
import Card from '../ui-elements/Card'

type Props = {
    checklistData: ObjectStringKeyAnyValue
    showIfNone: boolean
}


function ChecklistCategoryNames({
    checklistData,
    showIfNone = true
}: Props) {

    const {
        tableData,
        t
    } = useContext(GlobalContext)


    const [categoryNames, setCategoryNames] = useState<null | ObjectStringKeyAnyValue>(null)


    useEffect(() => {
        const newCategoryNames: ObjectStringKeyAnyValue = {}
        if (checklistData && tableData && tableData['ChecklistCategories'] && checklistData['ChecklistCategories']) {

            Object.keys(tableData['ChecklistCategories']).forEach((categoryTypeId: string) => {
                const categoryType = tableData['ChecklistCategories'][categoryTypeId]
                const categoryTypeDisplayName = categoryType['DisplayName']
                const categoryValues = categoryType['Values']
                const categoryValueNames: string[] = []

                if (categoryValues) {
                    Object.keys(categoryValues).forEach((categoryValueId: string) => {
                        const categoryValue = categoryValues[categoryValueId]
                        if (checklistData['ChecklistCategories'].includes(categoryValueId)) {
                            const categoryValueDisplayName = categoryValue['DisplayName']
                            categoryValueNames.push(categoryValueDisplayName)
                        }
                    })
                }
                if (categoryValueNames.length > 0) {
                    newCategoryNames[categoryTypeDisplayName] = categoryValueNames
                }
            })
            setCategoryNames(newCategoryNames)
        }
    }, [tableData, checklistData])

    if (!categoryNames && !showIfNone) {
        return null
    }

    return <div className={`flex flex-col`}>
        {!categoryNames && <p className={``}>{t('Dashboard.ChecklistCategoryNames.noCategories')}</p>}
        {categoryNames && Object.keys(categoryNames).map((categoryType: string) => {
            return <p key={categoryType} className={``}>{categoryType}: {categoryNames[categoryType].join(', ')}.</p>
        })}
    </div>
}
export default ChecklistCategoryNames